import { render } from "./LettersMailingsGroupsModal.vue?vue&type=template&id=563957f2&scoped=true"
import script from "./LettersMailingsGroupsModal.vue?vue&type=script&lang=js"
export * from "./LettersMailingsGroupsModal.vue?vue&type=script&lang=js"

import "./LettersMailingsGroupsModal.vue?vue&type=style&index=0&id=563957f2&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563957f2"]])

export default __exports__